import { useStationeryProductPricingContext } from '@apps/card/ProductUIConfig/utils/useStationeryProductPricingContext';
import { PriceSummaryProps } from './GenericPriceSummary';
import { useProductPriceSummaryController } from './ProductPriceSummary.controller';

// Enforce minimum quantities for products and validate before switching.
// PremiumDigital has price tiers with min tier min quantity of 50.
// Setting quantity to 50 or less paper cards then switching to Digital PDP
// will retain low quantity, and crash when trying to get price tier for low quantity,
// since one does not exist.
export const usePriceSummary = (args: Pick<PriceSummaryProps, 'templateCategory' | 'priceUpTo' | 'cardConfig' | 'promotion' | 'salesTax'>) => {
  const { cardConfig, priceUpTo, promotion, salesTax } = args;
  const { activeProduct, priceCalculator, attributeStates } = useStationeryProductPricingContext();
  const { getFullState } = attributeStates;
  const options = getFullState(cardConfig);

  const shouldShowShipping = priceUpTo === 'total';

  const summary = useProductPriceSummaryController(priceCalculator, cardConfig, activeProduct, options, shouldShowShipping, salesTax, promotion ?? undefined);
  return summary;
};
